import { ERC4337EthersProvider } from '@account-abstraction/sdk';
export class PassKeysProvider extends ERC4337EthersProvider {
    constructor(chainId, config, originalSigner, originalProvider, httpRpcClient, entryPoint, smartAccountAPI, accountAddress) {
        super(chainId, config, originalSigner, originalProvider, httpRpcClient, entryPoint, smartAccountAPI);
        this.chainId = chainId;
        this.config = config;
        this.originalSigner = originalSigner;
        this.originalProvider = originalProvider;
        this.httpRpcClient = httpRpcClient;
        this.entryPoint = entryPoint;
        this.smartAccountAPI = smartAccountAPI;
        this.accountAddress = accountAddress;
        if (accountAddress)
            this.accountAddress = accountAddress;
    }
}
